export default "__VITE_PUBLIC_ASSET__cda3ddd6__"